import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { doLogout } from "../store/user/actions/user.actions";
import { Box, CircularProgress } from "@mui/material";

export function RequireAccount({ children }) {
  const account = useSelector(
    (store) => store.accounts?.selectedAccount?.accountId
  );
  const accountTransition = useSelector((store) => store.auth?.accountTransition);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (!account) {
      const logoutAndRedirect = async () => {
        await doLogout();
        setShouldRedirect(true);
      };

      logoutAndRedirect();
    }
  }, [account]);

  if (accountTransition) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // enquanto faz logout, não renderiza nada
  if (!account && !shouldRedirect) return null;

  if (!account && shouldRedirect) {
    return <Navigate to="/" replace />;
  }

  return children;
}
